function getPlatform(): string {
  try {
    if (window.process) {
      return String(window.process.platform);
    }
  } catch (error) {
    return process.platform;
  }
  return 'browser';
}

// 避免出现window未定义
function getArch(): string {
  try {
    if (window.process) {
      return String(window.process.arch);
    }
  } catch (error) {
    return process.arch;
  }
  return 'x64';
}

export const platform: string = getPlatform();

export const arch: string = getArch();

/** 环境变量 */
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_BETA = process.argv.includes('--beta');
export const IS_DEV_PUBLISH = !!process.env.VUE_APP_DEV_PUBLISH;
export const IS_TEST = !!process.env.VUE_APP_TEST_PUBLISH;
export const IS_PRE = !!process.env.VUE_APP_PRE_PUBLISH;
export const IS_PUBLISH = !!process.env.VUE_APP_PUBLISH;
export const IS_PRIVATE = !!process.env.VUE_APP_PRIVATE;

// 标记pc端安装包是从哪个渠道下载过来的
export const PKG_PLATFORM = process.env.VUE_APP_PKG_PLATFORM;

// pc端测试环境打包时可设置为test1、test2等
export const HOST_PREFIX = process.env.VUE_APP_HOST_PREFIX;

/** 在操作系统中打开 网盘 PC 客户端 */
// windows 操作系统
export const IS_PC_IN_WIN = platform === 'win32';
// linux 操作系统
export const IS_PC_IN_LINUX = platform === 'linux';
// macOS 操作系统
export const IS_PC_IN_MAC = platform === 'darwin';
// 信创环境：linux环境 & arm64
export const IS_PC_IN_ARM_LINUX = IS_PC_IN_LINUX && arch === 'arm64';
// 环境：MAC OS M1
export const IS_PC_IN_M1_MAC = IS_PC_IN_MAC && arch === 'arm64';

/** 当前所处平台环境（浏览器环境） */
export const IS_BROWSER = platform === 'browser';
/** 当前所处平台环境（打开客户端应用） */
export const IS_PC = !IS_BROWSER;

/** 当前所处平台环境（移动端的浏览器环境）start */
const isMobile: boolean =
  IS_BROWSER &&
  (function isMobile() {
    if (window) {
      const exp =
        // eslint-disable-next-line max-len
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
      if (window.navigator.userAgent.match(exp)) {
        return true; // 移动端
      }
    }
    return false; // PC端
  })();
export const IS_BROWSER_IN_MOBILE = isMobile;

const isAndroid: boolean =
  isMobile &&
  (function isAndroid() {
    if (window) {
      const exp = /(Android|Adr|Linux)/i;
      if (window.navigator.userAgent.match(exp)) {
        return true;
      }
    }
    return false;
  })();
// 判断安卓环境
export const IS_BROWSER_IN_ANDROID = isAndroid;

const isIOS: boolean =
  isMobile &&
  (function isIOS() {
    if (window) {
      const exp = /(iPhone|iPod|iPad|iOS)/i;
      if (window.navigator.userAgent.match(exp)) {
        return true;
      }
    }
    return false;
  })();
// 判断ios环境
export const IS_BROWSER_IN_IOS = isIOS;

// 其他移动端设备
export const IS_BROWSER_IN_OTHER_MOBILE = isMobile && !isAndroid && !isIOS;
/** 当前所处平台环境（移动端的浏览器环境） end*/

/** 当前所处平台环境（某一平台上的浏览器环境）start */
const isBrowserInMac =
  IS_BROWSER &&
  (function isBrowserInMac() {
    if (window) {
      // platform 可能会被弃用，如果有该字段就先使用，无则用 userAgent
      const simpleCheck = window.navigator.platform.toUpperCase().includes('MAC');
      if (simpleCheck) return simpleCheck;
      const exp = /macintosh|mac os x/i;
      return exp.test(window.navigator.userAgent.toLowerCase());
    }
    return false;
  })();
// 判断 Mac 操作系统的浏览器环境
export const IS_BROWSER_IN_MAC = isBrowserInMac;

const isBrowserInArmLinux =
  IS_BROWSER &&
  (function isBrowserInArmLinux() {
    if (window) {
      // TODO: platform 可能会被弃用，如果有该字段就先使用，无则用 userAgent
      const simpleCheck = window.navigator.platform.toUpperCase().includes('LINUX AARCH64');
      return simpleCheck;
    }
    return false;
  })();
// 判断 Mac 操作系统的浏览器环境
export const IS_BROWSER_IN_ARM_LINUX = isBrowserInArmLinux;

// 在腾讯的应用(微信、企微)中打开网盘网页版
const inTencentApp =
  IS_BROWSER &&
  (function inTencentApp() {
    if (window) {
      const explorer = window.navigator.userAgent.toLowerCase();
      // 企微浏览器
      const inWxwork = explorer.indexOf('wxwork') >= 0;
      // 微信浏览器
      const inWechat = explorer.indexOf('micromessenger') >= 0;
      return inWxwork || inWechat;
    }
    return false;
  })();
export const IS_BROWSER_IN_TENCENT_APP = inTencentApp;
/** 当前所处平台环境（某一平台上的浏览器环境）start */

/** 在 Mac os 系统中打开了网盘(PC端或网页版 ) */
export const IS_OPEN_IN_MAC = IS_PC_IN_MAC || IS_BROWSER_IN_MAC;
/** 在 苹果 系统中打开了网盘(PC端或网页版 ) */
export const IS_OPEN_IN_APPLE = IS_PC_IN_MAC || IS_BROWSER_IN_MAC || IS_BROWSER_IN_IOS;
/** 在linux arm64 系统中打开了网盘(PC端或网页版 ) */
export const IS_OPEN_IN_ARM_LINUX = IS_PC_IN_ARM_LINUX || IS_BROWSER_IN_ARM_LINUX;
